import { Button, Grid, TextField, Typography } from "@mui/material";
import { Field, Formik, Form } from "formik";
import React from "react";
import * as yup from "yup";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useMutation } from "react-query";

export const StyledTextFieldContainer = styled(TextField)`
	width: 100%;
	display: flex;
	margin: 20px 0;
`;

const Container = styled(Form)`
	padding: 20px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	max-width: 800px;

	.MuiFormControl-root {
		margin: 10px 0;
	}
	.MuiTextField-root {
		margin: 20px 0;
	}
`;

const Login = ({ setToken }) => {
	const history = useNavigate();

	const mutation = useMutation({
		mutationFn: ({ username, password }) => {
			const url = `https://forum2023-be.vercel.app/auth?username=${username}&password=${password}`;
			return axios.post(url);
		},
	});

	React.useEffect(() => {
		if (mutation?.data?.status === 200) {
			setToken(`Bearer ${mutation?.data?.data}`);
			console.log("fwfwef", `Bearer ${mutation?.data?.data}`);
			history("/manage");
		}
	}, [mutation]);

	console.log(mutation);

	const handleSubmit = ({ username, password }) => {
		mutation.mutate({ username, password });
	};

	const createValidationSchema = () => {
		return yup.object({
			username: yup.string().required("Це поле є обов'язковим"),
			password: yup.string().required("Це поле є обов'язковим"),
		});
	};

	console.log("mutation.error", mutation.error);

	return (
		<>
			<Formik
				initialValues={{
					username: "",
					password: "",
				}}
				onSubmit={handleSubmit}
				validationSchema={createValidationSchema}
			>
				<Container>
					<Grid container alignItems="center">
						<Typography component="h1" variant="h5" align="center">
							Login
						</Typography>
						<Field name="username">
							{({ field, meta }) => {
								return (
									<StyledTextFieldContainer
										{...field}
										label="login"
										variant="outlined"
										error={meta.touched && !!meta.error}
										helperText={meta.touched && meta.error}
									/>
								);
							}}
						</Field>
						<Field name="password">
							{({ field, meta }) => {
								return (
									<StyledTextFieldContainer
										{...field}
										label="password"
										variant="outlined"
										type="password"
										error={meta.touched && !!meta.error}
										helperText={meta.touched && meta.error}
									/>
								);
							}}
						</Field>
						<Button variant="contained" fullWidth type="submit">
							Вхід
						</Button>
					</Grid>
				</Container>
			</Formik>
			{mutation.error && <p>{mutation.error?.response?.data}</p>}
		</>
	);
};

export default Login;
